import {motion} from "framer-motion";
import {ReactNode} from "react";

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}

// Central animation variants
export const pageVariants = {
  initial: {
    opacity: 0,
    y: 10,
    scale: 0.995,
  },
  in: {
    opacity: 1,
    y: 0,
    scale: 1,
  },
  out: {
    opacity: 0,
    y: -10,
    scale: 0.995,
  },
};

export const pageTransition = {
  type: "tween" as const,
  ease: "anticipate" as const,
  duration: 0.3,
};

// Faster variant for nested pages
export const fastPageVariants = {
  initial: {opacity: 0, y: 5},
  in: {opacity: 1, y: 0},
  out: {opacity: 0, y: -5},
};

export const fastPageTransition = {
  type: "tween" as const,
  ease: "easeInOut" as const,
  duration: 0.2,
};

// Slide variants for navigation
export const slideVariants = {
  initial: {opacity: 0, x: -20},
  in: {opacity: 1, x: 0},
  out: {opacity: 0, x: 20},
};

export const slideTransition = {
  type: "tween" as const,
  ease: "easeInOut" as const,
  duration: 0.25,
};

const PageTransition = ({children, className = ""}: PageTransitionProps) => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
      className={`page-transition ${className}`}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
